const hoy = new Date();
const FechaDesde = new Date(hoy);
FechaDesde.setDate(hoy.getDate() - 60);
FechaDesde.setHours(0, 0, 0, 0);

export default {
  Cliente: null,
  CodigoProductoPedido: null,
  DescripcionProducto: null,
  Estado: { Codigo: 1, Descripcion: 'Pendiente' },
  FechaDesde: null,
  FechaHasta: null,
  OrdenCompra: null,
  TipoProducto: null,
  Vendedor: null,
  CodigoPedido: null,
};
